import { Component, EventEmitter, Input, Output } from '@angular/core';


@Component({
  selector: 'lib-number-input',
  templateUrl: './number-input.component.html',
  styleUrl: './number-input.component.scss'
})
export class LibNumberInputComponent {

  @Input() default_value: number | null = null;
  @Input() max: number | null = null;

  value: number = 0;

  @Output() onChange: EventEmitter<number> = new EventEmitter();

  ngOnInit() {
    if (this.default_value ) {
      this.value = this._normalizeValue(this.default_value);
    }
  }

  private _normalizeValue(rawValue: number): number {
    let normalizedValue = Number.isNaN(rawValue) ? 0 : rawValue;

    if (normalizedValue < 0) {
      normalizedValue = 0;
    }

    if (this.max !== null && normalizedValue > this.max) {
      normalizedValue = this.max;
    }

    return normalizedValue;
  }

  private _updateValue(rawValue: number): void {
    this.value = this._normalizeValue(rawValue);
    this.onChange.emit(this.value);
  }

  decreaseQty() {
    this._updateValue(this.value - 1);
  }

  increaseQty() {
    this._updateValue(this.value + 1);
  }

  userInput(event: Event) {
    const target = event.target as HTMLInputElement;
    this._updateValue(Number(target.value));
  }
  
}